import { GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { DestinationsState, Destination } from './types';

export const getters: GetterTree<DestinationsState, GlobalState> = {
    currentDestinations(state): Destination[] | null {
        return state.destinations;
    },
    currentDestination(state): Destination | null {
        return state.selected;
    },
    currentDestinationName(state): string {
        if (!!state.selected) {
            return state.selected.name;
        }
        return "";
    },
};
